import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const employeeRolesManagement = createApi({
    reducerPath: "employeeRolesManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        roleList: builder.mutation({
            query: () => ({
                url: `v1/${locale}/settings/employees-roles`,
                method: "GET",
            }),
        }),
        viewRole: builder.mutation({
            query: (roleId) => ({
                url: `v1/${locale}/settings/employees-roles/${roleId}`,
                method: "GET",
            }),
        }),
        addRole: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/employees-roles`,
                method: "POST",
                body: body,
            }),
        }),
        updateRole: builder.mutation({
            query: ({ body, roleId }) => ({
                url: `v1/${locale}/settings/employees-roles/${roleId}`,
                method: "PATCH",
                body: body,
            }),
        }),
        deleteRole: builder.mutation({
            query: (roleId) => ({
                url: `v1/${locale}/settings/employees-roles/${roleId}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const { useRoleListMutation, useViewRoleMutation, useAddRoleMutation, useUpdateRoleMutation, useDeleteRoleMutation } = employeeRolesManagement;
